import React, { useContext, useEffect, useState } from 'react'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { strCol, numCol, dateCol, intCol } from '@integec/grid-tools/lib/cols'
import {
  getWind2Entity,
  getWind2OwnershipStatus,
  getWind2Regime,
  getWind2Scada,
  getWind2Shear,
  getWind2TurbineManufacture,
  getWind2Turbulence,
  renameWind2SubGroup,
  wind2AllPlant,
  wind2AllSubgroup,
  wind2AllSubgroupDelete,
  wind2AllSubgroupSave,
  wind2TurbineType,
} from 'api/pgads'
import Wind2SubgrouptModal from './Wind2SubgroupModal'
import R from 'ramda'
import { ErrorContext } from 'context'
import { toSelectionColProps } from '@integec/grid-tools'
import moment from 'moment'
import { Button } from 'antd'
import { HistoryModal, RenameModal } from 'wind2/wind2utils'

const title = 'Wind Subgroup'

const Wind2Subgroup = ({ apiTargetInfo }) => {
  const { setError } = useContext(ErrorContext)

  const [regimeMap, setRegimeMap] = useState({})
  const [ownershipStatusMap, setOwnershipStatusMap] = useState({})
  const [scadaMap, setScadaMap] = useState({})
  const [turbineMap, setTurbineMap] = useState({})
  const [turbulenceMap, setTurbulenceMap] = useState({})
  const [shearMap, setShearMap] = useState({})
  const [turbineTypeMap, setTurbineTypeMap] = useState({})
  const [plantMap, setPlantMap] = useState({})
  const [entityMap, setEntityMap] = useState({})
  const [showRenameModal, setShowRenameModal] = useState(false)
  const [showHistoryModal, setShowHistoryModal] = useState(false)

  useEffect(
    _ => {
      getWind2Regime(apiTargetInfo).fork(setError, data => {
        const regimeMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windRegimeId]: d.windRegime }))
        )
        setRegimeMap(regimeMap)
      })

      getWind2OwnershipStatus(apiTargetInfo).fork(setError, data => {
        const status = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.ownershipStatusCode]: d.ownershipStatusName }))
        )
        setOwnershipStatusMap(status)
      })

      getWind2Scada(apiTargetInfo).fork(setError, data => {
        const scadaMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.windScadaManufacturerId]: d.windScadaManufacturer,
          }))
        )
        setScadaMap(scadaMap)
      })

      getWind2TurbineManufacture(apiTargetInfo).fork(setError, data => {
        const turbineMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.windTurbineManufacturerId]: d.windTurbineManufacturer,
          }))
        )
        setTurbineMap(turbineMap)
      })

      getWind2Turbulence(apiTargetInfo).fork(setError, data => {
        const turbulence = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windTurbulenceId]: d.windTurbulence }))
        )
        setTurbulenceMap(turbulence)
      })

      getWind2Shear(apiTargetInfo).fork(setError, data => {
        const turbulence = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.windShearId]: d.windShear }))
        )
        setShearMap(turbulence)
      })

      wind2TurbineType(apiTargetInfo).fork(setError, data => {
        const turType = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.turbineTypeCode]: d.turbineType }))
        )
        setTurbineTypeMap(turType)
      })

      wind2AllPlant(apiTargetInfo).fork(setError, data => {
        const pm = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({ [d.plantId]: d.plantId + ' - ' + d.plantName }))
        )
        setPlantMap(pm)
      })

      getWind2Entity(apiTargetInfo).fork(setError, data => {
        const timezoneMap = R.reduce(
          (a, b) => ({ ...a, ...b }),
          {},
          data.map(d => ({
            [d.entityId]: d.entityId + ' - ' + d.entityName,
          }))
        )
        setEntityMap(timezoneMap)
      })
    },

    [apiTargetInfo, setError]
  )
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = insProps => (
    <Wind2SubgrouptModal
      {...insProps}
      insertEvent={insertEvent}
      setInsertEvent={setInsertEvent}
      regimeMap={regimeMap}
      ownershipStatusMap={ownershipStatusMap}
      scadaMap={scadaMap}
      turbineMap={turbineMap}
      turbulenceMap={turbulenceMap}
      shearMap={shearMap}
      turbineTypeMap={turbineTypeMap}
      plantMap={plantMap}
      entityMap={entityMap}
    />
  )

  const headers = Wind2SubgroupHeaders.map(hdr =>
    hdr.ident === 'entityId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) => entityMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            entityMap[rowData.entityId] || rowData.entityId,
        }
      : hdr.ident === 'plantId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) => plantMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            plantMap[rowData.plantId] || rowData.plantId,
        }
      : hdr.ident === 'windRegime'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            regimeMap[value] ? value + '-' + regimeMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            regimeMap[rowData.windRegime] || rowData.windRegime,
          ...toSelectionColProps(regimeMap),
        }
      : hdr.ident === 'scadaManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            scadaMap[value] ? value + '-' + scadaMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            scadaMap[rowData.scadaManufacturer] || rowData.scadaManufacturer,
          ...toSelectionColProps(scadaMap),
        }
      : hdr.ident === 'trubineManufacturer'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            turbineMap[value] ? value + '-' + turbineMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            turbineMap[rowData.trubineManufacturer] ||
            rowData.trubineManufacturer,
          ...toSelectionColProps(turbineMap),
        }
      : hdr.ident === 'turbulenceIntensity'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            turbulenceMap[value] ? value + '-' + turbulenceMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            turbulenceMap[rowData.turbulenceIntensity] ||
            rowData.turbulenceIntensity,
          ...toSelectionColProps(turbulenceMap),
        }
      : hdr.ident === 'windShearId'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            shearMap[value] ? value + '-' + shearMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            shearMap[rowData.windShearId] || rowData.windShearId,
          ...toSelectionColProps(shearMap),
        }
      : hdr.ident === 'subgroupOwnershipStatus'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            ownershipStatusMap[value]
              ? value + '-' + ownershipStatusMap[value]
              : value,
          sortIndexGetter: ({ rowData }) =>
            ownershipStatusMap[rowData.subgroupOwnershipStatus] ||
            rowData.subgroupOwnershipStatus,
          ...toSelectionColProps(ownershipStatusMap),
        }
      : hdr.ident === 'trubineType'
      ? {
          ...hdr,
          dataFormatter: ({ value }) =>
            turbineTypeMap[value] ? value + '-' + turbineTypeMap[value] : value,
          sortIndexGetter: ({ rowData }) =>
            turbineTypeMap[rowData.trubineType] || rowData.trubineType,
          ...toSelectionColProps(turbineTypeMap),
        }
      : hdr
  )

  const modifySaveDataBeforeSave = data => {
    return data.map(d => {
      let eff = d.effectiveDate
      if (eff && eff.length > 0)
        eff = moment(eff, 'MM/DD/YYYY').format('YYYY-MM-DD')
      let comm = d.commissionDate
      if (comm && comm.length > 0)
        comm = moment(comm, 'MM/DD/YYYY').format('YYYY-MM-DD')
      return { ...d, effectiveDate: eff, commissionDate: comm }
    })
  }
  const sortOnData = data => {
    return data.map(d => {
      let eff = d.effectiveDate
      if (eff && eff.length > 0) eff = moment(eff).format('MM/DD/YYYY')
      let comm = d.commissionDate
      if (comm && comm.length > 0) comm = moment(comm).format('MM/DD/YYYY')
      return { ...d, effectiveDate: eff, commissionDate: comm }
    })
  }

  const extraCriteriaAfterButton = ({
    data,
    onRetrieve,
    apiTargetInfo,
    setSpinning,
  }) => {
    return (
      <div>
        {showRenameModal && (
          <RenameModal
            list={data.map(e => ({
              label: e.subgroupId,
              value: e.subgroupId + '||' + e.plantId,
            }))}
            modalFor="Subgroup"
            hide={() => setShowRenameModal(false)}
            onOk={data => {
              const { oldId, newId } = data
              const ids = oldId?.split('||')

              setSpinning(true)
              renameWind2SubGroup(apiTargetInfo)({
                oldId: ids[0],
                plantId: ids[1],
                newId,
              }).fork(setError, _ => {
                setSpinning(false)
                onRetrieve()
              })
            }}
          />
        )}
        {showHistoryModal && (
          <HistoryModal
            dataName="TURBINE GROUP"
            apiTargetInfo={apiTargetInfo}
            setError={setError}
            hide={() => setShowHistoryModal(false)}
          />
        )}
        <Button
          onClick={() => setShowRenameModal(true)}
          type="primary"
          // style={{ marginLeft: '10px' }}
        >
          Rename Subgroup
        </Button>
        <Button
          onClick={() => setShowHistoryModal(true)}
          type="primary"
          style={{ marginLeft: '10px' }}
        >
          Show Rename History
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      sortOnData={sortOnData}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title={title}
      header={headers}
      saveTask={wind2AllSubgroupSave}
      retrieveTask={wind2AllSubgroup}
      deleteTask={wind2AllSubgroupDelete}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      altBy={d => d.subgroupName}
      autoRetrieve
      sortOptions={[
        strCol({
          ident: 'subgroupName',
          display: 'Subgroup Name',
          isKey: true,
          sortOrder: 'asc',
        }),
      ]}
      widthOffset={50}
      insertComp={insertEvent ? insertComp : false}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey
      headerRowHeight={60}
      defaultInsertData={{}}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Subgroup)

export const Wind2SubgroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 275,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    width: 275,
    ellipsis: true,
  }),
  // strCol({ ident: 'groupIdName', display: 'Group ID/Name', isFiltered: true }),
  intCol({ ident: 'subgroupId', display: 'Subgroup ID', isKey: true }),
  strCol({
    ident: 'subgroupName',
    display: 'Subgroup Name',
    isFiltered: true,
    isRequired: true,
    width: 250,
  }),
  numCol({
    ident: 'elevation',
    display: 'Elevation (m)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'windRegime',
    display: 'Wind Regime',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'annualAvgWindspeed',
    display: 'Annual Avg Windspeed (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaModel',
    display: 'SCADA Model',
    isFiltered: true,
    isRequired: true,
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'Commision Date (mm/dd/yyyy)',
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date (mm/dd/yyyy)',
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  numCol({
    ident: 'totalInstalledCap',
    display: 'Total Installed Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'numberTurbines',
    display: 'Number of Turbines',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'trubineSystemMw',
    display: 'Turbine System Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxTurbineCapacity',
    display: 'Max Turbine Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineManufacturer',
    display: 'Turbine Manufacturer',
    isFiltered: true,
    width: 300,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModel',
    display: 'Turbine Model',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModelVersion',
    display: 'Turbine Model Version',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineType',
    display: 'Turbine Type',
    isFiltered: true,
    width: 350,
    alignment: 'left',
    ellipsis: true,
    isRequired: true,
  }),
  numCol({
    ident: 'rotorHeight',
    display: 'Rotor Height (m)',
    isFiltered: true,
    isRequired: true,
    min: 0,
  }),
  numCol({
    ident: 'rotorDiameter',
    display: 'Rotor Diameter (m)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'cutInWindspeed',
    display: 'Cut-in Wind Speed (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'lowCutOutWindspeed',
    display: 'Low Cut-Out (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'highCutOutWindspeed',
    display: 'High Cut-Out (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'turbulenceIntensity',
    display: 'Turbulence Intensity',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 200,
    isRequired: true,
  }),
  numCol({
    ident: 'windShearId',
    display: 'Wind Shear',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 250,
    isRequired: true,
  }),
  numCol({
    ident: 'refAnemometerHeight',
    display: 'Ref. Anemometer Height',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'minOperatingTemp',
    display: 'Min Operating Temp (C)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxOperatingTemp',
    display: 'Max Operating Temp (C)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'subgroupOwnershipStatus',
    display: 'Subgroup Ownership Status',
    isFiltered: true,
    isRequired: true,
  }),

  strCol({
    ident: 'transferToEntity',
    display: 'Transfer to Entity ID',
    isFiltered: true,
  }),

  modifierCol,
  modifiedDateCol,
].map(d => ({ ...d, ellipsis: true }))
